import {Directive, inject, input, TemplateRef} from "@angular/core";

@Directive({
  selector: '[proFormaColumn]',
  standalone: false
})
export class HarbourDuesRotterdamProFormaColumnDirective {
  readonly header = input.required<string>({alias: 'proFormaColumn'});
  readonly type = input.required<ColumnType>();
  readonly template = inject(TemplateRef<any>);
}

export enum ColumnType {
  DESCRIPTION = "description",
  VALUE = "value",
  OPERATION = "operation",
  LINE_TOTAL = "lineTotal"
}
